import { attachErrorCodeDomain } from "./i18n-error-code-common";
import { errorCodeDomain as zhErrorCodes } from "./i18n/features/zh/error-code-redblue";
import { errorCodeDomain as enErrorCodes } from "./i18n/features/en/error-code-redblue";
import { errorCodeDomain as jaErrorCodes } from "./i18n/features/ja/error-code-redblue";

import { common as zhCommon } from "./i18n/common";
import { commonCatalog as enCommon } from "./i18n/features/en/common";
import { commonCatalog as jaCommon } from "./i18n/features/ja/common";
import { environmentTopologyVersions as enTopologyVersions } from "./i18n/features/en/environment-topology-versions";
import { platformAdmin as enPlatformAdmin } from "./i18n/features/en/platform-admin";
import { platformSupport as enSupport } from "./i18n/features/en/platform-support";
import { environmentTopologyVersions as jaTopologyVersions } from "./i18n/features/ja/environment-topology-versions";
import { platformAdmin as jaPlatformAdmin } from "./i18n/features/ja/platform-admin";
import { platformSupport as jaSupport } from "./i18n/features/ja/platform-support";
import { environmentTopologyVersions as zhTopologyVersions } from "./i18n/features/zh/environment-topology-versions";
import { platformAdmin as zhPlatformAdmin } from "./i18n/features/zh/platform-admin";
import { platformSupport as zhSupport } from "./i18n/features/zh/platform-support";
import {
  APP_LOCALE_LABELS,
  APP_LOCALES,
  DEFAULT_LOCALE,
  getLocale as sharedGetLocale,
  normalizeLocale,
  setLocale as sharedSetLocale,
  subscribeLocaleChange as sharedSubscribeLocaleChange,
} from "./i18n/locale-state";
import { createI18nRuntime } from "./i18n/runtime";

export type { AppLocale } from "./i18n/locale-state";
export { APP_LOCALE_LABELS, APP_LOCALES, DEFAULT_LOCALE, normalizeLocale } from "./i18n/locale-state";

const localeCatalogs = {
  "zh-CN": {
    common: zhCommon,
    platform: {
      admin: zhPlatformAdmin,
      environment: { topologyVersions: zhTopologyVersions },
      shareMode: zhSupport.shareMode,
    },
  },
  en: {
    common: enCommon,
    platform: {
      admin: enPlatformAdmin,
      environment: { topologyVersions: enTopologyVersions },
      shareMode: enSupport.shareMode,
    },
  },
  ja: {
    common: jaCommon,
    platform: {
      admin: jaPlatformAdmin,
      environment: { topologyVersions: jaTopologyVersions },
      shareMode: jaSupport.shareMode,
    },
  },
} as const;

export const {
  messageCatalogs,
  setLocale,
  getLocale,
  subscribeLocaleChange,
  createMessageProxy,
  hasMessage,
  t,
  formatMessage,
  formatEnumPath,
  formatEnumLabel,
  formatBooleanLabel,
  formatLocalizedList,
  formatActionObjectLabel,
  formatActionObjectMessage,
  formatActionObjectIntlLabel,
} = createI18nRuntime({
  defaultLocale: DEFAULT_LOCALE,
  localeCatalogs,
  normalizeLocale,
  localeState: {
    getLocale: sharedGetLocale,
    setLocale: sharedSetLocale,
    subscribeLocaleChange: sharedSubscribeLocaleChange,
  },
});

export type {
  DeepPartialMessageTree,
  FormatMessageLike,
  MessageDescriptor,
  MessageParams,
  MessageTree,
} from "./i18n/runtime";

// Error codes are app-owned: attach exactly the domain this transport renders.
attachErrorCodeDomain("redblue", {
  "zh-CN": zhErrorCodes,
  en: enErrorCodes,
  ja: jaErrorCodes,
});
